import { render, staticRenderFns } from "./homeBorrow.vue?vue&type=template&id=75b1585a&scoped=true&"
import script from "./homeBorrow.vue?vue&type=script&lang=js&"
export * from "./homeBorrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b1585a",
  null
  
)

export default component.exports